import { Wrap, Button } from './styles';

import Icon from '@map/components/Icons';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 */
import { useState } from 'react';
import Dropzone from 'react-dropzone';

/**
 * FileInput é um input de arquivos estilizado, e usado
 * em conjuto com o react-dropzone
 */
const FileInput = ({
  label,
  name,
  accept,
  maxSizeMb,
  onChange,
  extensionCheckMsg,
  style,
  variant = 'icon',
  ...props
}) => {
  const [dropZoneEnter, setDropZone] = useState(false);
  const [dropRejected, setDropRejected] = useState(false);
  const [error, setError] = useState(null);

  const onDrop = (files) => {
    let file = files[0];
    onChange && onChange(file);
    setDropZone(false);
    setDropRejected(false);
  };

  const onDropRejected = (files) => {
    setDropRejected(true);
    let file = files[0];

    const checkExtension = () => {
      if (accept) {
        let acceptedArray = accept.split(',');
        let fileExtension = file.name.split('.').pop();
        return acceptedArray.includes(`.${fileExtension}`);
      }
      return true;
    };
    const checkSize = () => {
      if (maxSizeMb) {
        let maxSizeBytes = maxSizeMb * 1000000;
        return file.size <= maxSizeBytes;
      }
      return true;
    };

    if (!checkExtension()) {
      setError(extensionCheckMsg);
    } else if (!checkSize()) {
      setError(`O tamanho do arquivo não pode ser maior que ${maxSizeMb} MB`);
    }
  };

  /**
   * Estrutura do componente input de arquivo
   * com uma zona de "arrasto"
   */
  return (
    <Wrap style={style}>
      {label ? <label htmlFor={name}>{label}</label> : null}
      <Dropzone
        onDropAccepted={onDrop}
        onDropRejected={onDropRejected}
        multiple={false}
        accept={accept}
        maxSize={maxSizeMb && maxSizeMb * 1000000}
        onDragEnter={() => {
          setDropZone(true);
          setDropRejected(false);
        }}
        onDragLeave={() => setDropZone(false)}
        {...props}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            className={`dropzone ${dropZoneEnter ? 'active' : ''} ${
              dropRejected ? 'rejected' : ''
            } ${props.disabled ? 'disabled' : ''}`}
            {...getRootProps()}
          >
            <input {...getInputProps()} />
            <div className="dropzone-body">
              {variant === 'icon' ? (
                <>
                  <Icon i="map-upload" />
                  <p>
                    Solte seu arquivo aqui para fazer upload <br /> ou
                    <span style={{ color: '#3c71dd' }}>
                      {' '}
                      selecione um arquivo
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <p style={{ margin: '0' }}>
                    Solte o arquivo aqui ou selecione o arquivo.
                  </p>
                  <Button variant="contained">Procurar Arquivo</Button>
                </>
              )}
            </div>
          </div>
        )}
      </Dropzone>
      {error && dropRejected && <span className="error">{error}</span>}
    </Wrap>
  );
};

FileInput.propTypes = {
  /** Label de identificação do input */
  label: PropTypes.string,
  /** Atributo name do input  */
  name: PropTypes.string,
  /** String contendo a lista de extensões aceitas, separadas por virgula. Ex: `.zip, .rar` */
  accept: PropTypes.string,
  /** Tamanho máximo em MB */
  maxSizeMb: PropTypes.string,
  /** `function(file)` */
  onChange: PropTypes.func,
  /** Mensagem de validação das extensões */
  extensionCheckMsg: PropTypes.string,
  /** Variante do Input */
  variant: PropTypes.oneOf(['icon', 'button']),
};

export default FileInput;
